<template>
  <div class="footer collapse-block">
    <div class="footer-overlay">
      <div class="collapse col-lg-12">
        <div class="card-row-edit">
          <div class="card-edit-content row">
            <div class="col col-lg-2">
              <label>Service Recipient State</label>
              <div class="card-edit-field col-lg-12" style="padding-left:0px;">
                <div class="content-list-title w150">
                  {{serviceReciepentState}}
                </div>
              </div>
            </div>
            <div class="col" v-if="!isForwardOneWay">
              <label>GST Method</label>
              <div class="section-radio" v-if="hideEdits">
                <Radio v-model="paid_to" @change="forwardReverseChange" label="1">
                  Forward
                </Radio>
                <Radio v-model="paid_to" @change="forwardReverseChange" label="2">
                  Reverse
                </Radio>
              </div>
              <div class="section-radio" v-else>
                <Radio v-model="paid_to"
                  v-if="paid_to==='1'"
                  label="1">
                  Forward
                </Radio>
                <Radio v-model="paid_to" disabled
                  v-else
                  @change="forwardReverseChange" label="1">
                  Forward
                </Radio>
                <Radio v-model="paid_to" v-if="paid_to==='2'" label="2">
                  Reverse
                </Radio>
                <Radio v-model="paid_to" disabled v-else label="2">
                  Reverse
                </Radio>
              </div>
            </div>
            <div class="col" v-else>
              <div class="content-list-title primary-text">
                GST Method
              </div>
              <div class="section-radio">
                <Radio v-model="paid_to"
                  @change="forwardReverseChange" label="1">
                  Forward
                </Radio>
                <Radio v-model="paid_to" @change="forwardReverseChange" label="2">
                  Reverse
                </Radio>
              </div>
            </div>
            {{paid_to}}
            <div class="col" v-if="isFCM && hideEdits">
              <div class="content-list-title primary-text">
                GST percentage
              </div>
              <Multiselect :options="transporterNonGst.igst_tax"
                @select="percentageSelected"
                :value="selectedPercentage"
                placeholder="Service Provider State" selectLabel='' />
            </div>
            <div class="col" v-if="!hideEdits && canShowNote">
              <label>{{noteLabel}} - ({{noteAmount}} INR)</label>
              <div class="card-edit-field col-lg-12" style="padding-left:0px;">
                <div class="content-list-title w150">
                {{noteValue}}
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 content-section-right">
              <div class="content-list" v-for="(remits, index) in remits"
                :key="index">
                  <span class="content-list-title">
                    {{remits.label}} {{remits.percentage}}%: <b>
                      {{Number(remits.amount).toFixed(2)}}</b>
                  </span>
              </div>
              <div class="content-section" v-if="$hasFeature('transporter_payment_discount')">
                <div class="content-list">
                  <span class="content-list-title">
                    Discount {{discount}}%: <b>{{Number(discountAmount).toFixed(2)}}</b>
                  </span>
                </div>
                <div class="content-list">
                  <span class="content-list-title">
                    Sub Total : <b>{{Number(subTotal).toFixed(2)}}</b>
                  </span>
                </div>
              </div>
              <div class="content-section" v-if="isSameState">
                <div class="content-list">
                  <span class="content-list-title">
                    CGST {{state_tax}}% : <b>{{Number(total_state_tax).toFixed(2)}}</b>
                  </span>
                </div>
                <div class="content-list">
                  <span class="content-list-title">
                    SGST {{central_tax}}%: <b>{{Number(total_central_tax).toFixed(2)}}</b>
                  </span>
                </div>
              </div>
              <div class="content-section" v-else>
                <div class="content-list">
                  <span class="content-list-title">
                    IGST {{igst_tax}}%: <b>{{Number(total_igst_tax).toFixed(2)}}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-row-edit">
          <div class="card-edit-content row">
            <div class="col-lg-8 input-field" v-if="hideEdits">
              <div class="col-auto content-list">
                <div class="content-list-title">
                  <Multiselect :options="options"
                    @select="stateSelected"
                    track-by="name"
                    :value="selectedState"
                    label="name"
                    placeholder="Service Provider State" selectLabel='' />
                </div>
              </div>
              <div class="col-auto content-list">
                <div class="content-list-title">
                  <input class="input" type="text" placeholder="Enter GSTN"
                :value="gstno" @input="updateGstNo">
                </div>
              </div>
              <div class="col-auto content-list">
                <div class="content-list-title">
                  <input class="input" type="text" placeholder="Invoice No"
                    @input="updateInvoice">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-section">
        <div class="col-lg-6 col-md-6 no-padding footer-section-left" v-if="!showNote">
          <div class="footer-section-total">Total Orders:
            <span class="order-no">{{orderCount}}</span>
          </div>
        </div>
        <div class="float-right" v-on:click="seen = !seen">
            <!-- <svgicon name="arrow-down" v-if="!seen" class="icon"
                    width="14" height="14" :original="true" />
            <svgicon name="arrow-up" v-if="seen" class="icon"
                    width="14" height="14" :original="true" /> -->
          <div class="col-lg-6 col-md-6 no-padding footer-section-right">
            <div class="footer-section-order-list" v-if="!isApproved">
              <div class="order-content-list">
                <span class="order-content-title" >Requested:</span>
              </div>
              <div class="order-content-list">
                <span class="order-content-number">
                  <span class="inr-style">INR </span>
                  {{Number(totalAmount).toFixed(2)}}
                </span>
              </div>
            </div>
            <div class="footer-section-order-list" v-if="isApproved">
              <div class="order-content-list">
                <span class="order-content-title" >Net Payable:</span>
              </div>
              <div class="order-content-list">
                <span class="order-content-number">
                  <span class="inr-style">INR </span>
                  {{Number(approvedAmount).toFixed(2)}}
                </span>
              </div>
            </div>
          </div>
          <div v-if="seen">
            <div class="col-lg-12 col-md-12 no-padding footer-section-right">
              <div class="col-lg-12 col-md-12 footer-section-order-list">
                <!--<div class="order-content-list">
                  <span class="order-content-title">Sample</span> <br/>
                  <span class="order-content-number">
                  <span class="inr-style">INR </span>
                  1234
                </span>
              </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import states from '@/constants/india-states';
import PaymentRemits from '@/lib/payment-remits';
import paymentVue from '../list/payment.vue';

export default {
  components: {
    Multiselect,
  },
  data() {
    const payment = this.$store.payments.selected[0];
    const {
      igst_tax: igstTax,
      paid_to: paidTo,
      state_tax: stateTax,
      central_tax: centralTax
    } = this.$store.payments
    const sourcestate = payment.destination_state;
    const selectedState = states.find(state => state.name === sourcestate);
    this.$store.payments.selectedState = selectedState;
    const paid_to = `${paidTo}`;
    return {
      activeNames: ['1'],
      paid_to,
      isForwardOneWay: paid_to === '1',
      options: states,
      selectedState,
      igst_tax: igstTax,
      state_tax: stateTax,
      central_tax: centralTax,
      isSameState: payment.same_state === 2,
      total_state_tax: 0,
      total_central_tax: 0,
      total_amount: 0,
      total_igst_tax: 0,
      remits: [],
      discount: 0,
      discountAmount: 0,
      subTotal: 0,
      test: this.$store.payments.gstno,
      forward_changed: false,

      invoiceno: '',
      seen: false,
    };
  },
  computed: {
    orderCount() {
      return this.$store.payments
        && this.$store.payments.selected ? this.$store.payments.selected.length : 0;
    },
    gstno() {
    const transporter = this.currentTransporter;
    const transporterGst = transporter.gst_details.find(gst =>
      gst.client_id === this.currentClient.id);
    this.$store.payments.gstno = (transporterGst) ? transporterGst.number : '';
    return this.$store.payments.gstno;
    },
    currentTransporterGST() {
      const transporter = this.currentTransporter;
      return transporter.gst_details.find(gst => gst.client_id === this.currentClient.id);
    },
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
      currentClient: 'app/currentClient',
      transporterNonGst: 'app/transporterNonGst',
      currentClientConfig: 'app/currentClientConfig',
    }),
    serviceReciepentState() {
      let state = this.$store.payments
        && this.$store.payments.selected && this.$store.payments.selected.length > 0
        ? this.$store.payments.selected[0].depot.state : '';
      this.$store.payments.sourcestate = state;
      return state;
    },
    showNote() {
      return this.$store.showNote;
    },
    noteAmount() {
      return (this.$store.invoice.revision && this.$store.invoice.revision.value) ?
        this.$store.invoice.revision.value : 0;
    },
    isApproved() {
      let approved = false;
      if (this.$store.invoice && this.$store.invoice.status){
        approved = this.$store.invoice.status >= 3;
      }
      return approved;
    },
    selectedPercentage() {
      return this.igst_tax;
    },
    totalAmount() {
      let amount =  this.showNote ? this.$store.invoice.revision.value:
      this.$store.payments.transporter_total;
      this.remits = this.paymentRemits(amount);
      if (this.remits.length) {
        amount = this.calculateRemitAmount(this.remits, amount);
      }
      const isForward = this.paid_to === '1';
       if (this.$hasFeature('transporter_payment_discount') &&
        this.currentTransporterGST.payment_discount) {
        this.discount = this.currentTransporterGST.payment_discount;
        this.discountAmount = (amount * (this.currentTransporterGST.payment_discount / 100));
        amount = (amount - this.discountAmount);
        this.subTotal = amount;
      }
      if (this.isSameState) {
        this.total_state_tax = amount * (this.state_tax / 100);
        this.total_central_tax = amount * (this.central_tax / 100);
        this.total_amount = isForward ? (this.total_state_tax + this.total_central_tax)
          + amount : amount;
      } else {
        this.total_igst_tax = amount * (this.igst_tax / 100);
        this.total_amount = isForward ? this.total_igst_tax + amount : amount;
      }
      return this.total_amount;
    },
    approvedAmount() {
      let amount =  this.showNote ? this.$store.invoice.revision.value:
      this.$store.payments.client_total;
      this.remits = this.paymentRemits(amount);
      const isForward = this.paid_to === '1';
      if (this.isSameState) {
        this.total_state_tax = amount * (this.state_tax / 100);
        this.total_central_tax = amount * (this.central_tax / 100);
        this.total_amount = isForward ? (this.total_state_tax + this.total_central_tax)
          + amount : amount;
      } else {
        this.total_igst_tax = amount * (this.igst_tax / 100);
        this.total_amount = isForward ? this.total_igst_tax + amount : amount;
      }
      return this.total_amount;
    },
    isFCM() {
      return  this.paid_to === '1';
    },
    hideEdits() {
      return !this.$store.showInvoice;
    },
    canShowNote() {
      return this.$store.invoice
      && this.$store.invoice.revision
      && this.$store.invoice.revision.number;
    },
    noteLabel() {
      return this.$store.invoice.revision.type === 1 ?
      'Credit Note Number' : 'Debit Note Number';
    },
    noteValue() {
      return this.$store.invoice.revision.number;
    },
  },
  methods: {
    updateInvoice(data) {
      const { target } = data;
      this.invoiceno = target.value;
      this.$store.payments.invoiceno = target.value;
    },
    updateGstNo(data) {
      const { target } = data;
      this.$store.payments.gstno = target.value;
    },
    paymentRemits(amount) {
      const invoiceFields = (this.currentClientConfig.invoice_fields) ?
        this.currentClientConfig.invoice_fields: [];
      return PaymentRemits(invoiceFields, amount);
    },
    forwardReverseChange() {
      const payment = this.currentTransporterGST;
      const isForward = this.paid_to === '1';
       this.$emit('paidtochanged', this.paid_to);
      if (isForward) {
        if(payment.paid_to === 2) {
          this.igst_tax = this.transporterNonGst.igst_tax[0];
          this.state_tax = (this.transporterNonGst.igst_tax[0] / 2);
          this.central_tax = (this.transporterNonGst.igst_tax[0] / 2);
          this.forward_changed = false;
        } else {
          this.igst_tax = payment.percentage;
          this.state_tax = (payment.percentage / 2);
          this.central_tax = (payment.percentage / 2 );
          this.forward_changed = false;
        }

      } else {
       this.state_tax = 2.5;
        this.central_tax = 2.5;
        this.igst_tax = 5;
        this.forward_changed = true;
      }
      this.$store.payments.igst_tax = this.igst_tax;
      this.$store.payments.paid_to = this.paid_to;
    },
    stateSelected(selectedState) {
      this.selectedState = selectedState;
      this.isSameState = this.serviceReciepentState === selectedState.name;
      this.$store.payments.selectedState = selectedState;
    },
    percentageSelected(selected) {
      this.state_tax = (selected / 2);
      this.central_tax = (selected / 2);
      this.igst_tax = selected;
      this.$store.payments.igst_tax = selected;
    },
    calculateTotal() {
      const payments = this.$store.payments.selected;
      let totalTax = 0;
      const isIgst = payments[0].transporter.same_state === 1;
      const isVendorTaxPay = payments[0].transporter.paid_to === 1;
      payments.forEach((payment) => {
        const tax = isVendorTaxPay ? payment.transporter.service_charge :
          payment.transporter.no_tax;
        totalTax += Number(tax);
      });
      this.total_amount = isVendorTaxPay ?
      this.$store.payments.total_amount + totalTax
      : this.$store.payments.total_amount;
    },
    calculateRemitAmount(remitFields = [], amount = 0) {
      let paymentAmount = amount;
      let remitsTotal = 0;
      remitFields.forEach(field => {
        switch(field.method) {
          case 1:{
            paymentAmount = paymentAmount + field.amount;
            break;
          }
          case 2:{
            paymentAmount = paymentAmount - field.amount;
            break;
          }
        }
      });
      return paymentAmount;
    }
  },
};
</script>
<style lang='scss' scoped>
.input-field {
    padding: 0 0 10px;
    .content-list {
        display: inline-block;
        .input {
            border-bottom: 1px solid #E5E5E5;
            border-left: none;
            border-right: none;
            border-top: none;
            height: 40px;
            width: 300px;
            padding: 10px;
            border-radius: 2px;
            outline: none;
        }
    }
}
.collapse {
    padding: 15px 10px;
    &-img {
        text-align: center;
        padding: 0 0 15px;
    }
}
.multiselect__tags {
  border: 1px solid #DEE5E6;
}
.multiselect {
  min-width: 200px;
}
.multiselect__single {
  color: #969696;
}
.section-radio {
  padding-top: 10px;
}
.collapse-block{
  .collapse{
    display: block;
    .card-row-edit{
      padding: 3px 6px 3px;
    }
    .card-edit-content{
          margin-top: 2px;
    }
  }
}
</style>
